import { createContext } from 'react';

export type DetailsViewContextType = {
  useShouldRefetchData: (cb: () => void) => void;
  broadcastShouldRefetchData: () => void;
};

// @ts-ignore
export default createContext<DetailsViewContextType>();
